import Noty from 'noty';
import $ from 'jquery';

if ($.browser.mobile) {
    Noty.setMaxVisible(3);
    Noty.overrideDefaults({
        timeout: 7000,
        layout: 'topCenter'
    });
} else {
    Noty.overrideDefaults({
        timeout: 20000,
        layout: 'bottomRight'
    });
}

Noty.overrideDefaults({
    theme: 'main_app',
    callbacks: {
        onTemplate: function () {
            this.barDom.innerHTML = `
                <div class="app_notyWrapper noty_message noty_message__hellow">
                    <span class="noty_text">${this.options.text}</span>
                    <div class="noty_close"></div>
                </div>
            `;
        }
    }
});
